import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from "react";
import { useSaveFulfillmentSettings, ChooseSubscriptionScreen, activeFulfillmentIdVar, saveToFutureFulfillmentsVar } from '@withfriendsco/wf-components';
import WelcomeGiftVariant from "./WelcomeGiftVariant";
import { useCopyAddress } from "cache/WelcomeGiftVariantFunctions";
const VariantScreen = ({ id, welcomeGiftId, isAfterPurchase }) => {
    const copyAddress = useCopyAddress({
        sourceId: id,
        targetId: welcomeGiftId,
    });
    const { wrapped: saveWelcomeGift } = useSaveFulfillmentSettings({
        id: welcomeGiftId
    });
    useEffect(() => {
        activeFulfillmentIdVar(id);
        return () => {
            activeFulfillmentIdVar(null);
        };
    }, [id]);
    return (_jsxs("div", { className: "flex flex-wrap justify-center font-sans px-4", children: [welcomeGiftId && id ? (_jsxs(_Fragment, { children: [_jsx(WelcomeGiftVariant, { id: welcomeGiftId }), _jsx("div", { className: "w-full" })] })) : null, _jsx(ChooseSubscriptionScreen, { id: id || welcomeGiftId, saveCallback: async () => {
                    saveToFutureFulfillmentsVar(false);
                    if (welcomeGiftId && id) {
                        copyAddress();
                        await saveWelcomeGift();
                    }
                    activeFulfillmentIdVar(null);
                }, isAfterPurchase: isAfterPurchase, hasWelcomeGift: !!welcomeGiftId && !!id })] }));
};
export default VariantScreen;
